const initialState = {
  host: '',
  isReactNative: false,
  platform: '', // iOS or Android in React Native.
};

const reducer = (
  state = initialState,
) => state;

export default reducer;



// WEBPACK FOOTER //
// ./src/common/device/reducer.js